import { useQuery } from '@tanstack/react-query'
import { getJSON } from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

type Health = { status: string; service: string; time: string }

export default function HealthPage() {
  const { data, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['health'],
    queryFn: () => getJSON<Health>('/api/v1/health'),
  })

  return (
    <main className="mx-auto max-w-xl px-6 py-6">
      <h1 className="text-heading-sm font-semibold">AMS</h1>

      <Card className="mt-4">
        <CardContent className="p-4">
          {isLoading && <p>Checking API…</p>}
          {isError && <p className="text-destructive">API unreachable</p>}
          {data && (
            <p>
              API · <span className="font-mono">{data.status}</span> · {data.service}
            </p>
          )}
        </CardContent>
      </Card>

      <Button className="mt-4" disabled={isFetching} onClick={() => refetch()}>
        {isFetching ? 'Checking…' : 'Re-check'}
      </Button>
    </main>
  )
}
